import { InjectionToken } from '@angular/core';

import { Country } from '@recruitee/http-types';

import { SelectOption } from '../forms/select/select.component';

export type CountrySelectOption = SelectOption & { countryCode: number };

export const PHONE_INPUT_DATA = new InjectionToken<Country[]>('PHONE_INPUT_DATA');
